import IosShareIcon from '@mui/icons-material/IosShare'

export default ({show}) => show ? <div className="shareButton"><IosShareIcon className='text-black'/></div> : ""